<script>
export default {
  props: {
    form: {
      type: Array,
      required: true,
    },
    user: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      default() {
        return {}
      },
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {
      default() {
        return {}
      },
    },
  },
  beforeDestroy() {
    var doc = this.$refs['builder' + this.user]
    if (doc !== undefined) doc.innerHTML = ''
  },
  methods: {
    deleteData(name, data) {
      if (data.name !== undefined) this.$emit('delete', data)
      else {
        this.$emit('delete', { name: name, data: data })
      }
    },
    editData(data) {
      this.$emit('edit', data)
    },
    sendData(name, event) {
      this.$emit('update', { name: name, data: event })
    },
    deleteFile(name, event) {
      this.$emit('delete', { name: name, id: event })
    },
  },
}
</script>

<template>
  <div :ref="'builder' + user">
    <div v-for="(field, key) in form" :key="key">
      <div class="clear"></div>

      <!-- <div
        v-if="field.more !== undefined && field.more.info !== undefined"
        :class="$style.guideBoard"
        class="mb20"
      >
        <div class="clear"></div>
        <span :class="$style.guideBoardIcon"></span>
        <p :class="$style.guideBoardText"
          ><b>Note : </b>{{ field.more.info }}</p
        >
        <div class="clear"></div>
      </div> -->

      <component
        :is="field.typeComponent"
        :id="field.id !== undefined ? field.id : field.name"
        :validation="field.validation"
        :type="field.type"
        :name="field.name"
        :form="field.form"
        :user="user"
        :value="
          field.typeComponent === 'FormBaseHideShow' ||
          field.typeComponent === 'FormBaseAddmore'
            ? value
            : value[field.value]
        "
        :label="field.label"
        :options="field.options"
        @update="sendData(field.value, $event)"
        @edit="editData"
        @delete="deleteData(field.value, $event)"
      ></component>

      <div class="clear"></div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
